module.exports = __webpack_public_path__ + "static/media/guaranteed-departure.bb84c00b.svg";